<template>
  <div :class="one ? 'container containerNew' : 'container'">
    <div class="common-header-wrap">
        <mt-header :title="$t('MyCommission')" class="common-header">
            <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div style="padding-bottom: 100px">
      <div class="tabs">
        <div class="tab" v-for="(item, index) in tabs" :key="index" @click="tabClick(index)">
          <span :class="{ active: index === activeTab }">
            {{ $t(item.gc_name) }}
          </span>
        </div>
      </div>
      <div class="list" ref="listWrapper" @scroll="handleScroll"  v-if="dataList && dataList.length && activeTab != 2">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="sn-date flex">
            <div class="uname">
              {{ $t("Username") }}:
              {{ item.from_member_name ? item.from_member_name : "" }}
            </div>
            <div class="date">{{ item.create_time}}</div>
          </div>
          <div class="rk" v-if="item.remark">
            {{ item.remark }}
          </div>
          <div class="price-type flex">
            <div class="sn">sn: {{ item.order_sn }}</div>
            <div class="price">{{ item.num }}USDT</div>
          </div>
        </div>
      </div>
      <div class="list" v-else-if="dataList && dataList.length && activeTab == 2">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="sn-date flex">
            <div class="l">
              <div class="date">{{ item.create_time}}</div>
            </div>
            <div class="r">{{ item.status_text || $t("succ") }}</div>
          </div>
        </div>
      </div>
      <div class="empty" v-else-if="dataList && !dataList.length">
        <empty-record></empty-record>
      </div>
    </div>

    <mt-datetime-picker ref="picker" type="date" :cancelText="$t('MessageBox.Cancel')"
      :confirmText="$t('MessageBox.Confirm')" v-model="pickerValue" :endDate="endDate_" @confirm="changeTime"
      @touchmove.native.stop.prevent>
    </mt-datetime-picker>
  </div>
</template>

<script>
import {
  getCommissionList,
  getCommissionLogList,
  getCommissionInfo,
  createToken,
} from "../../../api/memberInviter";
import EmptyRecord from "../../../components/EmptyRecord";
import { Indicator } from "mint-ui";
export default {
  name: "MemberInviterUser",
  components: {
    EmptyRecord,
  },
  props: {
      one: {
          default: false,
          type: Boolean
      },
  },
  data() {
    return {
      params: {
        page: 0,
        limit: 10,
        date: "",
        type: "luck_buy_commission_1",
      },
      form_token: "",
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      dataList: false,
      type: this.$route.query.type ? this.$route.query.type : 0,
      pickerValue: "",
      endDate: "",
      endDate_: new Date(),
      value: "",
      tabs: [
        {
          gc_name: "Direct",
          type: "luck_buy_commission_1",
        },
        {
          gc_name: "Indirect",
          type: "luck_buy_commission_2",
        }
      ],
      activeTab: this.$route.query.indexe ? this.$route.query.indexe : 0,
      info: null,
    };
  },
  created() {
    this.tabClick(0)
    createToken().then((res) => {
      if (res.code == 10000) {
        this.form_token = res.result.form_token;
      }
    });
  },

  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleScroll() {
      const container = this.$refs.listWrapper;
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      if (scrollBottom < 10) {
        this.loadMore();
      }
    },
    onPage(v, val) {
        this.$emit('onPage', v, val)
    },
    tabClick(index) {
      this.activeTab = index;
      if (index == 1) {
        this.params.type = "luck_buy_commission_2";
      } else{
        this.params.type = "luck_buy_commission_1";
      }
      this.dataList = false;
      this.getDataList(false);
    },
    getDataList(ispush) {
      Indicator.open();
      let params = this.params;
      if (!ispush) {
        params.page = 1;
      }

      if (this.activeTab == 2) {
        getCommissionLogList(params).then((res) => {
          Indicator.close();
          if (res.code == 10000) {
            if (ispush && this.dataList) {
              this.dataList = this.dataList.concat(res.result);
            } else {
              this.dataList = res.result;
            }
            this.isMore = true;
          }
        });
      } else {
        getCommissionList(params).then((res) => {
          Indicator.close();
          if (res.code == 10000) {
            if (ispush && this.dataList) {
              this.dataList = this.dataList.concat(res.result);
            } else {
              this.dataList = res.result;
            }
          }
        });
      }
    },
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getDataList(true);
      }
    },
    //打开时间选择器
    openPicker() {
      if (this.endDate) {
        this.pickerValue = this.endDate;
      } else {
        this.pickerValue = new Date();
      }
      this.$refs.picker.open();
    },
    //时间选择器选中
    changeTime(value) {
      let date = this.utils.formatDate_(value, "yyyy-MM-dd");
      this.params.date = date;
      this.dataList = [];
      this.getDataList(false);
      this.endDate = value;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100vh;
  padding-bottom: 1px;

  .logo_box {
    position: fixed;
    top: 25px;
    left: 12px;
    z-index: 99;

    img {
      width: 3.5rem;
    }
  }
}

body {
  width: 100%;
  background-color: transparent;
  top: 100px;
  height: 100vh;
}

.info_box {
  padding: 20px 12px;

  .info {
    background-image: url("../../../assets/image/mybgc1.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 1.2rem;

    .item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;

      .k {
        width: 7rem;
        color: #7f7f7f;
        font-size: 15px;
      }

      .v {
        font-size: 25px;
        color: #000000;
      }

      .b {
        background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
        border-radius: 50px;
        font-size: 12px;
        color: #ffffff;
        padding: 5px 10px;
        margin-left: 0.6rem;
      }
    }

    .tips {
      border-bottom: 1px solid RGBA(255, 224, 223, 1);
      border-radius: 50px;
      font-size: 12px;
      color: #fb2933;
      background: RGBA(255, 241, 241, 1);
      padding: 10px 12px;
    }
  }
}

.inviter-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;

  border-bottom: 1px solid #e4e4e4;

  .avatar {
    width: 4.5rem;

    img {
      width: 4rem;
    }
  }

  .inviter {
    flex: 1;
    font-size: $subFontSize;

    .users {
      font-size: $h3;
    }

    .time {
      color: gray;
      margin-top: 0.2rem;
    }
  }
}

.tabs {
  padding-left: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  height: 2.5rem;

  .tab {
    flex: 1;
    text-align: center;
    font-size: $fontSize;
    color: #333;
    padding: 10px 12px;
  }

  span {
    font-weight: bold;
    font-size: 15px;
    padding: 0px 12px;
  }

  .active {
    color: #000;
    padding: 0rem 0.7rem;
    border-bottom: none;
    background-image: url("../../../assets/image/underline.png");
    background-size: 50px 5px;
    background-repeat: no-repeat;
    background-position: left 10px bottom;
    display: inline-block;
  }
}

.list {
  height: 85vh;
  overflow-y: auto;
  margin: 10px;
  padding: 0 12px;
  border-radius: 20px;
  border: 1px solid #707070;
  font-size: 0.6rem;
  background-color: #fff;

  .item {
    padding: 20px 0;
    border-bottom: 1px solid #bbbbbb;

    &:last-child {
      border-bottom: none;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .num {
        font-size: 0.7rem;
        color: #000;
        font-weight: 600;
        margin-bottom: 0.1rem;
      }

      .r {
        color: #e67f54;
        font-size: 0.7rem;
        font-weight: 600;
      }
    }

    .uname {
      font-size: 0.6rem;
    }

    .sn {
      font-size: 0.6rem;
    }

    .date {
      font-size: 0.57rem;
      color: #8d839c;
    }

    .rk {
      font-size: 0.8rem;
      padding: 10px;
      border-radius: 10px;
    }

    .price-type .price{
      color: #e67f54;
    }
  }
}

.empty {
  padding: 0px 12px;
}

.gobuy-head {
  width: 100%;
  height: 4.2rem;
  position: fixed;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-image: url("../../../assets/image/homeHbgc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .logo {
    top: 25px;
    left: 12px;
    z-index: 99;
    margin: .5rem 0;

    img {
      width: 3.5rem;
    }
  }

  .common-header-wrap {
    z-index: 10;
    top: 54px;
    width: 100%;

    .common-header {
      color: #fff;
      box-shadow: none;
      background-color: #F15E60;
    }
  }

  .zhwnwei {
    height: 4.76rem;
  }
}
</style>
